import EVirtTable from './EVirtTable';
import defaultLang from './lang/zh-CN';
export type LangConfig = typeof defaultLang;

export default class Locale {
    private langConfig?: LangConfig;
    use(langConfig: LangConfig) {
        this.langConfig = langConfig;
    }
    getText(key: string, params?: Record<string, any>) {
        const config = { ...defaultLang };
        // 合并全局默认语言配置
        Object.assign(config, EVirtTable.locale, this.langConfig);
        const text = config[key as keyof LangConfig];
        if (!text) {
            return '';
        }
        return text.replace(/{(\w+)}/g, (match, p1) => params?.[p1] || match);
    }
}
